<template>
  <div class="after_sale_info_warp">
    <el-alert
      v-if="$route.query.groupBuy === '1'"
      :title="`拼团订单${$route.query.teamNo ? ' · 拼团编号：' + $route.query.teamNo : ''}`"
      description="该订单来自拼团活动，拼团进度和成员请在活动管理的拼团情况中查看。"
      type="warning"
      show-icon
      :closable="false"
      class="group-buy-alert"
    />
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">收货信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="联系姓名">{{ orderInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ orderInfo.phone }}</el-descriptions-item>
          <el-descriptions-item label="联系地址">
            {{ orderInfo.countryName }}
            {{ orderInfo.provinceName }}
            {{ orderInfo.cityName }}
            <span v-if="orderInfo.areaName">{{ orderInfo.areaName }}</span>
            {{ orderInfo.address }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">订单处理日志</div>
      </div>
      <div class="card_content">
        <el-timeline v-if="orderInfo.operationLogs && orderInfo.operationLogs.length">
          <el-timeline-item
            v-for="log in orderInfo.operationLogs"
            :key="log.id || `${log.operation}-${log.ctdate}`"
            :timestamp="formatApiDate(log.ctdate)"
            placement="top"
          >
            <el-card shadow="never">
              <strong>{{ operationName(log.operation) }}</strong>
              <p>操作人：{{ log.operatorName || operatorTypeName(log.operatorType) }}</p>
              <p v-if="log.remark">说明：{{ log.remark }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无订单处理日志" :image-size="70" />
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">订单信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="订单编号">{{ orderInfo.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="用户姓名">{{ orderInfo.userName }}</el-descriptions-item>
          <el-descriptions-item label="用户手机号">{{ orderInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{
            formatApiDate(orderInfo.ctdate)
          }}</el-descriptions-item>
          <el-descriptions-item label="支付时间">{{
            formatApiDate(orderInfo.payTime)
          }}</el-descriptions-item>
          <el-descriptions-item label="发货时间">{{
            formatApiDate(orderInfo.deliveryTime)
          }}</el-descriptions-item>
          <el-descriptions-item label="确认收货时间">{{
            formatApiDate(orderInfo.takeTime)
          }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            {{
              orderInfo.modifyShippingAddressStatus === 1
                ? "修改地址中"
                : getValue(ORDER_STATUS, orderInfo.status)
            }}
          </el-descriptions-item>
          <el-descriptions-item label="备注">{{ orderInfo.remark }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">商品信息</div>
      </div>
      <div class="card_content">
        <el-table :data="orderInfo.items" style="width: 100%" size="mini">
          <el-table-column prop="id" label="明细编号" width="120"></el-table-column>
          <el-table-column prop="goodsId" label="商品编号" width="120"></el-table-column>
          <el-table-column prop="title" label="商品名称"> </el-table-column>
          <el-table-column label="商品条目" min-width="220">
            <template slot-scope="scope">
              <div class="sku-cell">
                <div>{{ scope.row.skuName || scope.row.goodsSpece || "-" }}</div>
                <div class="sku-spec" v-if="formatSkuSpec(scope.row)">
                  {{ formatSkuSpec(scope.row) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mainGraph" label="商品图" width="100">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.skuImage || scope.row.mainGraph"
                fit="cover"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column prop="expressTime" label="卖家发货时间">
            <template slot-scope="scope">
              <span>{{ formatApiDate(scope.row.expressTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="expressNo" label="发货单号">
            <template slot-scope="scope">
              <div class="express-number-cell">
                <span>{{ scope.row.expressNo || "-" }}</span>
                <el-tooltip v-if="isMultiPackage" content="查看全部包裹物流" placement="top">
                  <el-button
                    type="text"
                    icon="el-icon-view"
                    class="package-view-button"
                    aria-label="查看全部包裹物流"
                    @click="openPackageDialog"
                  ></el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="expressName" label="卖家发货快递"></el-table-column>
          <el-table-column prop="unitPrice" label="商品单价"> </el-table-column>
          <el-table-column prop="buyNum" label="商品数量"> </el-table-column>
          <el-table-column prop="goodsAmount" label="商品总金额"> </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog
      title="包裹物流信息"
      :visible.sync="packageDialogVisible"
      :close-on-click-modal="false"
      width="760px"
      append-to-body
    >
      <el-table
        v-loading="packageLoading"
        :data="deliveryPackages"
        border
        size="small"
        empty-text="暂无包裹物流信息"
      >
        <el-table-column label="包裹" width="90" align="center">
          <template slot-scope="scope">包裹 {{ scope.row.packageNo || scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.status === 1 ? "已发货" : "待补充" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="expressName" label="快递公司" min-width="150">
          <template slot-scope="scope">{{ scope.row.expressName || "-" }}</template>
        </el-table-column>
        <el-table-column prop="expressNo" label="快递单号" min-width="190">
          <template slot-scope="scope">{{ scope.row.expressNo || "-" }}</template>
        </el-table-column>
        <el-table-column label="发货时间" min-width="170">
          <template slot-scope="scope">
            {{ formatApiDate(scope.row.shippedTime || scope.row.expressTime) }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="packageDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <div class="dialog-footer">
      <el-button type="primary" @click="returnList">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getDeliveryPackages, getOrderDetail } from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import { AFTER_SALE_STATUS, getValue, ORDER_POSTAGES_TYPE, ORDER_STATUS } from "@/utils/enumUtile";

export default {
  name: "orderInfo",
  computed: {
    isMultiPackage() {
      return this.deliveryPackages.length > 1;
    },
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_POSTAGES_TYPE() {
      return ORDER_POSTAGES_TYPE;
    },
    ORDER_STATUS() {
      return ORDER_STATUS;
    },
    AFTER_SALE_STATUS() {
      return AFTER_SALE_STATUS;
    }
  },
  data() {
    return {
      id: 0,
      orderInfo: {},
      listLoading: false,
      packageLoading: false,
      packageDialogVisible: false,
      deliveryPackages: []
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.id = id;
      this.getList();
    }
  },
  watch: {},
  methods: {
    getValue,
    operationName(value) {
      const names = {
        SUBMIT: "用户提交订单",
        IMPORT: "后台导入订单",
        DELIVERY: "订单发货",
        CONFIRM_RECEIPT: "确认收货",
        AFTER_SALE_APPLY: "发起售后"
      };
      return names[value] || value || "订单操作";
    },
    operatorTypeName(value) {
      return { USER: "用户", ADMIN: "后台操作人", SYSTEM: "系统" }[value] || "未知操作人";
    },
    onExpressNo() {
      window.open(
        "https://www.baidu.com/s?rsv_idx=1&wd=%E6%9F%A5%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2%E5%85%A5%E5%8F%A3",
        "_blank"
      );
    },
    openPackageDialog() {
      this.packageDialogVisible = true;
    },
    loadDeliveryPackages() {
      if (!this.id) {
        this.deliveryPackages = [];
        return Promise.resolve();
      }
      this.packageLoading = true;
      return getDeliveryPackages({ id: this.id })
        .then(response => {
          this.deliveryPackages = Array.isArray(response.data) ? response.data : [];
        })
        .catch(() => {
          this.deliveryPackages = [];
        })
        .finally(() => {
          this.packageLoading = false;
        });
    },
    getList() {
      const id = this.id;
      if (!id) {
        return;
      }
      this.listLoading = true;
      const params = {
        id
      };
      getOrderDetail(params)
        .then(response => {
          this.orderInfo = response.data || [];
          return this.loadDeliveryPackages();
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    formatSkuSpec(row) {
      if (!row || !row.specValuePath) {
        return "";
      }
      try {
        const spec = JSON.parse(row.specValuePath);
        return Object.keys(spec)
          .map(key => `${key}: ${spec[key]}`)
          .join("; ");
      } catch (e) {
        return row.goodsSpece || "";
      }
    },
    returnList() {
      this.$router.push({ path: this.$route.query.groupBuy === "1" ? "/activity/group-buy/orders" : "/order/list" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/index";

.aa {
  display: inline-block;
}

.express-number-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.package-view-button {
  min-width: 28px;
  padding: 4px;
  font-size: 16px;
}

.after_sale_info_warp {
  background-color: #eeeeee;
  padding: 20px;
  height: calc(100vh - 124px);
  overflow-y: auto;
  .group-buy-alert {
    margin-bottom: 20px;
  }
  .box-card {
    margin-bottom: 20px;
  }
  .card_title {
    display: flex;
    align-items: center;
    .card_title_fg {
      height: 22px;
      width: 4px;
      background-color: $Theme-color;
    }
    .card_title_msg {
      margin-left: 6px;
    }
  }
  .card_content {
    margin-top: 10px;
    .descriptions_mar_warp {
      margin-top: 20px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: end;
  }
  .sku-cell {
    line-height: 1.5;
  }
  .sku-spec {
    margin-top: 4px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
